/**
 * Type definitions for descriptor testing functionality
 * Aligned with backend DTOs
 */

/**
 * Request payload for testing descriptor mapping
 * Maps to backend DescriptorMappingTestRequestDTO
 */
export interface DescriptorTestRequest {
    reportId?: number;                  // Optional: Use existing report
    reportContent?: string;             // Optional: Ad-hoc report content
    includeExplanations: boolean;       // Default: true
    confidenceThreshold: number;        // Default: 0.7
}

/**
 * Individual term mapping result
 * Maps to backend TermMappingResultDTO
 */
export interface TermMappingResult {
    termId: number;
    term: string;
    definition: string;
    mapped: boolean;
    confidenceScore?: number;
    explanation?: string;
    matchedPhrases?: string[];
}

/**
 * Mapping statistics
 * Maps to backend MappingStatisticsDTO
 */
export interface MappingStatistics {
    totalTerms: number;
    mappedTerms: number;
    averageConfidence?: number;
    highConfidenceMatches?: number;
}

/**
 * LLM Error structure
 */
export interface LLMError {
    code: number;
    message: string;
    details?: string;
}

/**
 * Response from descriptor mapping test
 * Maps to backend DescriptorMappingTestResponseDTO
 */
export interface DescriptorTestResponse {
    descriptorId: number;
    descriptorName: string;
    mappings: TermMappingResult[];
    statistics?: MappingStatistics;
    processingTimeMs?: number;
    error?: LLMError;
    modelUsed?: string;
}

/**
 * Component state for descriptor testing
 */
export interface DescriptorTestState {
    testContent: string;
    isLoading: boolean;
    error: string | null;
    results: DescriptorTestResponse | null;
    includeExplanations: boolean;
    confidenceThreshold: number;
}

/**
 * Default configuration for descriptor testing
 */
export const DEFAULT_TEST_CONFIG = {
    includeExplanations: true,
    confidenceThreshold: 0.7,
    maxContentLength: 10000
};